module.exports = __webpack_public_path__ + "static/media/icon-attachment.a9275774.svg";